import { useRootLoaderData } from "../routing/useRootLoaderData";
import type { User } from "~/models/user/User";

export default function useOptionalUser(): User | undefined {
  return useRootLoaderData().user ?? undefined;
}
